<script>
import {onMounted, ref} from "vue";
import 'vue3-carousel/dist/carousel.css'
import {Carousel, Slide} from 'vue3-carousel'
import FreeWorld from "@/assets/js/FreeWorld";
import {useStore} from "vuex";
import L from "leaflet";
import router from "@/router";
import swal from "sweetalert2";
// import { Clipboard } from '@capacitor/clipboard';
import useClipboard from 'vue-clipboard3'
import Swals from "@/assets/js/Swals";
import $ from "jquery";


export default {
  name: "DetailsAdvertising",
  components: {
    Carousel,
    Slide,
  },
  setup() {

    let store = ref(useStore())
    let loading = ref(false)
    let details = ref(null)
    let uid = ref(FreeWorld.PinkMan(localStorage.getItem('uid'), 'de'))

    store.value.state.advertising !== null ? details.value = FreeWorld.PinkMan(store.value.state.advertising, 'de') : router.push({name: 'HomePage'})

    function marked() {
      let data = {
        action: 'add_mark',
        second_id: details.value.id,
        type: 'adver',
      }

      $("#mark").addClass('pe-none')

      details.value.mark = !details.value.mark
      FreeWorld.Heisenberg(data, 'mark', true).then((res) => {
        if (res.data.status !== 'ok') details.value.mark = !details.value.mark
        $("#mark").removeClass('pe-none')
      }).catch((res) => {
        details.value.mark = !details.value.mark
        $("#mark").removeClass('pe-none')
        Swals.Catch(res, marked)
      })
    }


    const {toClipboard} = useClipboard()

    function copy_phone() {
      swal.fire({
        title: 'شماره همراه:',
        text: details.value.phone,
        confirmButtonText: 'کپی کردن',
      }).then((res) => {
        if (res.isConfirmed) {
          try {
            toClipboard(details.value.phone)
            Swals.Done('شماره همراه کپی شد')
          } catch (e) {
            Swals.Fault('شماره همراه کپی نشد!')
          }
        }
      })
    }

    function chat_adver() {
      let data = ref({
        receiver_id: details.value.user_id,
        pic: details.value.pic1,
        chat_info: details.value.title,
        adver_id: details.value.id
      })


      store.value.commit('set_chat', data.value)
      router.push({name: 'ChatsPage', params: {type: 'profile_adver'}})
    }

    // ****** map ******

    let map
    let marker = L.ExtraMarkers.icon({
      shape: 'circle',
    })

    function load_map() {
      setTimeout(() => {
        map = L.map('map').setView([details.value.lat, details.value.lang], 13)
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map)
        map.setView([details.value.lat, details.value.lang], 13)
        L.marker([details.value.lat, details.value.lang], {icon: marker}).addTo(map)
      }, 100)
    }

    onMounted(() => {
      load_map()
    })

    function report_advertising() {
      Swals.Question(`آیا آگهی ${details.value.title} را گزارش میدهید؟` , 'گزارش دادن').then((res)=>{
        if (res.isConfirmed){
          loading.value = true

          setTimeout(()=>{
            loading.value = false
            Swals.Done('گزارش شما ثبت شد')
          },1000)
        }
      })
    }


    return {
      loading,
      details,
      copy_phone,
      marked,
      store,
      uid,
      chat_adver,
      report_advertising,
    }
  }
}
</script>

<template>

  <div id="main" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center justify-content-between p-4">
      <div class="d-flex">
        <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
             alt="">
        <p class="text-white font-bold font-4 d-flex align-items-center">جزئیات آگهی</p>
      </div>

      <div class="d-flex align-items-center">
        <img @click="report_advertising" src="../assets/img/icon-block-user.svg" class="icon-size-3 ms-3" alt="">

      <img v-if="!details.mark" @click="marked" id="mark" class="icon-size-3" src="../assets/img/icon-mark-NA.svg"
           alt="">
      <img v-else id="mark" @click="marked" class="icon-size-3" src="../assets/img/icon-mark-A.svg" alt="">
      </div>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div class="slider rounded-5 mb-4">
        <carousel class="slider" :items-to-show="1">
          <slide v-for="(item , index) in details.pics" :key="index" class="slider rounded-4">
            <img class="w-100 h-100 rounded-4 img-cover" :src="item" alt="">
          </slide>
        </carousel>
      </div>

      <div class="p-3 shadow-custom rounded-4 mb-3">
        <p class="text-color font-bold font-4 mb-2">{{ details.title }}</p>
        <p class="font-5">{{ details.time }} در {{ details.state }} - {{ details.city }}</p>
      </div>

      <div class="d-flex justify-content-between mb-3">
        <div style="width: 33.3%" class="ps-3">
          <div class="shadow-custom p-3 rounded-4">
            <p class="text-center mb-2">کارکرد</p>
            <p v-if="details.km" class="text-center">{{ details.km }}</p>
            <p v-else class="text-center">مشخص نشده</p>
          </div>
        </div>

        <div style="width: 33.3%" class="ps-3">
          <div class="shadow-custom p-3 rounded-4">
            <p class="text-center mb-2">نوع وسیله</p>
            <p class="text-center">{{ details.adver_category }}</p>
          </div>
        </div>

        <div style="width: 33.3%" class="">
          <div class="shadow-custom p-3 rounded-4">
            <p class="text-center mb-2">سال ساخت</p>
            <p v-if="details.year" class="text-center">{{ details.year }}</p>
            <p v-else class="text-center">مشخص نشده</p>
          </div>
        </div>
      </div>

      <div class="p-3 shadow-custom rounded-4 d-flex align-items-center justify-content-between mb-3">
        <p class="font-bold font-4">قیمت کل</p>
        <p v-if="Number(details.price) > 0" class="font-5 d-flex">{{ details.price.toLocaleString() }} تومان</p>
        <p v-else class="font-5 d-flex">توافقی</p>
      </div>

      <div class="p-3 shadow-custom rounded-4 mb-3">
        <p class="font-bold font-4 mb-2">توضیحات</p>
        <p class="font-5">{{ details.caption }}</p>
      </div>

      <div id="map" class="map p-3 shadow-custom rounded-4 mb-5"></div>

      <div v-if="uid !== details.user_id" class="d-flex justify-content-around">
        <p @click="copy_phone"
           class="font-4 text-white font-bold p-3 rounded-pill bg-color-liner text-center w-35 shadow-custom">اطلاعات
          تماس</p>
        <p @click="chat_adver"
           :to="{name:'ChatsPage' , params:{type:'adver' , chat_id:details.user_id , adver_id: details.id}}"
           class="font-4 text-decoration-none text-white font-bold p-3 rounded-pill bg-color-liner text-center w-35 shadow-custom">
          چت</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.slider {
  width: 100%;
  height: 20rem !important;
}

.map {
  height: 15rem;
}
</style>